module.exports = __webpack_public_path__ + "static/media/AI_7.d08d0392.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_7.png
// module id = 122
// module chunks = 0